import { Query_Root } from 'src/@types/graphql'
import { Client, gql } from 'urql'

const fetchProgramsGrid = gql`
  query ($isGfsUser: Boolean!) {
    kap_program {
      id
      modules
      canton_code
      dossier {
        short_title
        status
        start_date
        end_date
        first_open_milestone @include(if: $isGfsUser) {
          type
          year_in_focus
        }
      }
    }
  }
`

export interface KapFetchRowsPromise {
  rows: Array<{
    id: number
    short_title: string
    canton_code: string
    status: string
    start_date: string
    end_date: string
    curr_milestone_type?: string
    curr_milestone_year?: number
    modules?: string[]
  }>
}

export const fetchKapRows =
  (urqlClient: Client) =>
  async (isGfsUser: boolean): Promise<KapFetchRowsPromise> => {
    const { data, error } = await urqlClient
      .query<
        {
          kap_program: Query_Root['kap_program']
        },
        {
          isGfsUser: boolean
        }
      >(fetchProgramsGrid, {
        isGfsUser: isGfsUser,
      })
      .toPromise()

    if (error) {
      return Promise.reject(error)
    } else {
      const fetchedRows = data!.kap_program.map((program) => ({
        id: program.id,
        short_title: program.dossier.short_title,
        canton_code: program.canton_code,
        status: program.dossier.status,
        modules: program.modules,
        start_date: program.dossier.start_date,
        end_date: program.dossier.end_date,
        curr_milestone_type: program.dossier.first_open_milestone?.[0]?.type,
        curr_milestone_year: program.dossier.first_open_milestone?.[0]?.year_in_focus,
      }))
      return {
        rows: fetchedRows,
      }
    }
  }
